import type { Condition } from '../types/conditions';
import type { FormEmbeddedTableNode } from '../types/layout';

/** Build layout node from domain `embedded-table` property (model + domain.json). */
export function embeddedTableLayoutNode(prop: Record<string, unknown>): FormEmbeddedTableNode {
  return {
    type: 'embedded-table',
    schemaRef: prop.schemaRef as string,
    ...(prop.hiddenWhen != null &&
      typeof prop.hiddenWhen === 'object' && { hiddenWhen: prop.hiddenWhen as Condition }),
    ...(prop.title != null && { title: prop.title as string }),
    ...(prop.filter != null &&
      typeof prop.filter === 'object' && { filter: prop.filter as Record<string, unknown> }),
    ...(prop.features != null &&
      typeof prop.features === 'object' && { features: prop.features as Record<string, unknown> }),
    ...(prop.actionParamMap != null &&
      typeof prop.actionParamMap === 'object' && {
        actionParamMap: prop.actionParamMap as Record<string, unknown>,
      }),
    ...(prop.hideToolbar === true && { hideToolbar: true }),
  };
}
